import { Injectable,inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ReportStatesService {
  private apiUrl = environment.apiUrl + '/report_states/';  // Usa la variable global
  private http = inject(HttpClient); // Inyección sin constructor

  get():Observable<any>{
    return this.http.get(this.apiUrl+'get')
  }
  getById(id:string):Observable<any>{
    let headers = new HttpHeaders().set('Content-Type', 'application/json')
    return this.http.get(this.apiUrl+'get/'+id)
  }
  update(id: string, userData: any): Observable<any> {
    console.log(userData)
    let headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http.put(this.apiUrl + 'update/' + id, userData);
  }

  save(userData: any): Observable<any> {
    return this.http.post(this.apiUrl+ 'save/', userData);
  }
}

